// edit date: 2023-12-10
    // msword.54M.js
    // myStyle.css
// // const webpackConfig = require('./webpack.config')();
// import getWebpackConfig from '../webpack.config.js';
// const webpackConfig = getWebpackConfig();
// console.log(webpackConfig);
import 'babel-polyfill';
import 'whatwg-fetch';

import './scss/style.scss';
import './css/myStyle.css';
import './css/loading.css';
import './ttf/allFont.css';

import './css/myButtons.css'

var navBar           = {};
window.navBar           = navBar;

var $ = require('jquery'); // use require for older version
window.$ = $;
window.jQuery = $; // needed for bootstrap
require('jquery-color')
require('./js/jquery-getAttributes')
require('bootstrap')
import 'bootstrap/dist/css/bootstrap.min.css';

import regeneratorRuntime, { async } from "regenerator-runtime";

// import Mustache from "mustache";
var Mustache = require('mustache')
window.Mustache = Mustache;
// import {BookList} from "./json/List2021-06-23.js" //"./json/Lists.js"
import {PrayerList,FontList} from "./json/Lists.js"
window.PrayerList = PrayerList;
var BookList = []
var TextList = []
var UserList = []
var ContentList = [];
// window.ContentList = ContentList
import * as JSZip from "./js/jszip.js";
import {xmlToJson} from "./js/xmlToJson"
import {wF, StyleList,styleJsonToCss2} from "./js/msword.54M"
import * as bNavbar from "./js/bootstrapNav2M"
window.bNavBar = bNavbar;
import { fb } from './js/fb.js'
window.fb = fb;
var firebase = fb;

import {SmartPrint,startPrintMode} from "./js/print.js"
window.SmartPrint = SmartPrint;
window.startPrintMode = startPrintMode;

import {setParam,appendParam,removeParam,getParam,getAllParam,delParam}  from "./js/searchParamsFunctions.js"
console.log({setParam,appendParam,removeParam,getParam,getAllParam,delParam} )


var cachedStyles        = {};
var defaultMenuLanguage = window.localStorage.getItem('defaultMenuLanguage')
var defaultContentSelector = "#output";
var contentSelector = contentSelector || defaultContentSelector || "";
var cueList$;
var cuePosition;
var cuePositionBookmark;
var EasyViewerVersion = "3.1.8" // 2024-03-22 updated scroll behavier // inline
var EVdefaultSettings = {
    version: "1.0.1",
    fontSize: '24px',
    multicolumn:"off",
    LineNumber: "visible",// "hidden",
    LinePosition: "on", // on,off
    Language:{
        Tibetan:{
            getSelector: 'p[class^="tib"]',
            setSelector: 'p.tib',
            fontFamily: "Sambhota",
            fontSize: "1em",
            display: 'block'
        },
        English:{
            getSelector: 'p[class^="eng"]',
            setSelector: 'p.eng',
            fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            fontSize: "0.7em",
            display: 'none'
        },
        Chinese:{
            getSelector: 'p[class^="chin"]',
            setSelector: 'p.chin',
            fontFamily: "KaiTi, 楷体, PMingLiU",
            fontSize: "1.0em",
            display: 'block',
            pinying: 'pin-ying-off',
            'font-family': {
                'pin-ying-off': [ // setting for setStyleAll
                    [   'p[class^="chin"] '+
                        'ping1 span.ping1 span[class$="Ping1"] '+
                        'ping2 span.ping2 span[class$="Ping2"] '+
                        'ping3 span.ping3 span[class$="Ping3"] '+
                        'ping4 span.ping4 span[class$="Ping4"] '+
                        'ping5 span.ping5 span[class$="Ping5"] '+
                        'ping6 span.ping6 span[class$="Ping6"]', // space delimited selector
                        'fontFamily', // style to change
                        'DFKai-SB'] // style value
                ],
                'pin-ying-on': [
                    ['p[class^="chin"]','fontFamily','StdKaiXHYL1EG-Md'], // set chin to L1
                    ['ping1 span.ping1 span[class$="Ping1"]','fontFamily', 'StdKaiXHYL1EG-Md'], // set ping1 to L1
                    ['ping2 span.ping2 span[class$="Ping2"]','fontFamily', 'StdKaiXHYL2EG-Md'], // set ping1 to L2
                    ['ping3 span.ping3 span[class$="Ping3"]','fontFamily', 'StdKaiXHYL3EG-Md'], // set ping1 to L3
                    ['ping4 span.ping4 span[class$="Ping4"]','fontFamily', 'StdKaiXHYL4EG-Md'], // set ping1 to L4
                    ['ping5 span.ping5 span[class$="Ping5"]','fontFamily', 'StdKaiXHYL5EG-Md'], // set ping1 to L5
                    ['ping6 span.ping6 span[class$="Ping6"]','fontFamily', 'StdKaiXHYL6EG-Md'], // set ping1 to L6
                ]
            }
        },
        ChinesePinYing:{
            pingying: 'off',
            getSelector: 'p[class^="chin"]',
            setSelector: 'p.chin',
            fontFamily: [
                [   'p[class^="chin"]','fontFamily','DFKai-SB'],
                [
                    'ping1 span.ping1 span[class$="Ping1"] '+
                    'ping2 span.ping2 span[class$="Ping2"] '+
                    'ping3 span.ping3 span[class$="Ping3"] '+
                    'ping4 span.ping4 span[class$="Ping4"] '+
                    'ping5 span.ping5 span[class$="Ping5"] '+
                    'ping6 span.ping6 span[class$="Ping6"]','fontFamily','DFKai-SB'],
               ],
            // fontSize: "0.8em", // 2021-06-12 remove: will reset Chinses.fontSize
            display: 'block'
        },
        German: {
            getSelector: 'p[class^="ger"]',
            setSelector: 'p.ger',
            fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            fontSize: "1em",
            display: 'none'
        }
    },
    settings: {}
 };

var EVdefault={}
window.EVdefault = EVdefault;

window.bNavbar = bNavbar;

window.contentSelector = "#output";

navBar.navbarBrandText  = '';
navBar.navbarLeftList   = [];
navBar.navbarCenterList = [];
navBar.navbarRightList  = [];

try{
    window.EVdefault = JSON.parse(window.localStorage.getItem("EasyViewer")) || EVdefaultSettings;
    console.log(window.EVdefault)
    var searchParams = new URLSearchParams(location.search); console.log(searchParams)

}catch{
    window.EVdefault = EVdefaultSettings
}

// functions
    function getValOf2(jsonObj,propertyPath){
        var keys = propertyPath.split('.');
        for(var a=0;a<keys.length;a++){
            if (jsonObj[keys[a]] == undefined) {
                return false; // return false
            }
            jsonObj = jsonObj[keys[a]]; // check next obj
        }
        return jsonObj;
     }
    //  getValOf2(styleJson,'styles.docDefaults.rPrDefault.rPr')
    function getParasV1(){
        var para={}
        window.location.search.split(/\?|\&/).filter(f=>f).map(m=>{
            var a = m.split('=')
            para[a[0]]=a[1];
            })
        return para;
     }
    function getParas() {
        const urlParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlParams.entries());
     }
    function setPrayerOld(prayer){
        $.getJSON("json/" + prayer, function(data) { console.log(data);
            var innerTemplate = "{{#text}}<{{tag}} {{#class}}class='{{class}}'{{/class}}  {{#textId}}id='{{textId}}'{{/textId}}  {{#href}}href='{{href}}'{{/href}}>{{{html}}}</{{tag}}>{{/text}}";
            var template = "{{#myData}}<{{tag}} {{#class}}class='{{class}}'{{/class}}  {{#id}}id='{{id}}'{{/id}}  {{#href}}href='{{href}}'{{/href}}>" + innerTemplate + "</{{tag}}>{{/myData}}";
            var html = Mustache.render(template, data);

            $('#Viewer').html(html);
            $('title').text(data.name);
            $("html, body").animate({ scrollTop: 0 }, "slow");

        });
        }


    function isElementInViewport(el) {
        var rect = el.getBoundingClientRect(); //onsole.log(rect.top, rect.bottom, window.innerHeight);
        return (
            rect.top >= 0 &&
            rect.bottom < window.innerHeight
        );
        }
        window.isElementInViewport = isElementInViewport;
    function isElementVisible(el) {
        var rect     = el.getBoundingClientRect(),
            vWidth   = window.innerWidth || doc.documentElement.clientWidth,
            vHeight  = window.innerHeight || doc.documentElement.clientHeight,
            efp      = function (x, y) { return document.elementFromPoint(x, y) };

        // Return false if it's not in the viewport
        if (rect.right < 0 || rect.bottom < 0
                || rect.left > vWidth || rect.top > vHeight)
            return false;

        // Return true if any of its four corners are visible
        return (
                el.contains(efp(rect.left,  rect.top))
            ||  el.contains(efp(rect.right, rect.top))
            ||  el.contains(efp(rect.right, rect.bottom))
            ||  el.contains(efp(rect.left,  rect.bottom))
        );
        }

    function htmlNormalize(html){
        // if ($('#Viewer>div.cue').length >0 && $('#Viewer>div.cue').length == $('#Viewer>div.cue>div[class^="tib"]').length ){
        //     console.log('no normalization needed')
        //     return html;
        // }
        var Viewer = $(html);
        // create myViewer
        var myViewer = $('<div id="Viewer"></div>');
        // find all elements which are inside a .cue
        // var myElements = $(Viewer).find('>'); console.log( myElements)
        var myElements = $(Viewer); console.log( myElements)
        // add first cue in myViewer
        var myCueId = 1;
        $(myViewer).append(`<div class="cue" id="${myCueId}"></div>`);
        // look through all elements
        for (var a=0,b=0;b<myElements.length;b++){
            // check if next element is undefined or has a class starting with tib
            if ( myElements[b+1] == undefined || /^tib/.test( myElements[b+1].className ) ){ //console.log(a,b)
                // append a~b range to myViewer
                for (var c=a;c<=b;c++){ //console.log(myElements[c].outerHTML);
                    if (myElements[c].tagName == 'P'){
                        $(myViewer).find(`#${myCueId}`).append( $(myElements[c]).clone() )
                    }else{ //if (myElements[c].tagName == 'SPAN'){
                        $(myViewer).find(`#${myCueId}`).append(`<p class="${myElements[c].className}">${myElements[c].outerHTML}</p>` )
                    }
                }
                // reset range
                a=b+1;
                // has more elements then add next cue with id
                if (a<myElements.length){
                    myCueId++;
                    $(myViewer).append(`<div class="cue" id="${myCueId}"></div>`);
                }
            }
        }
        // return html
        return myViewer[0].innerHTML
        console.log( myViewer[0].outerHTML )
        }

    function addCues(html,part,file){ //console.log('addCues',ContentList[part])
        var Viewer = $(html);
        // create myViewer
        var myViewer = $('<div id="Viewer" style="z-index:-10000;"></div>');
        var myElements = $(Viewer); //console.log( myElements)
        // add first cue in myViewer
        var myCueId = 1;
        //// $(myViewer).append(`<div class="cue" id="${part>0?`${part}_`:''}${myCueId}"></div>`);
        $(myViewer).append(`<div class="cue" id="${part}_${myCueId}" style="z-index:-${myCueId}" ${myCueId==1?` data-file="${file}"`:``}></div>`);
        // look through all elements
        for (var a=0,b=0;b<myElements.length;b++){
            // check if next element is undefined or has a class starting with tib
            if ( myElements[b+1] == undefined || /^tib/.test( myElements[b+1].className ) ){ //console.log(a,b)
                // append a~b range to myViewer
                for (var c=a;c<=b;c++){ //console.log(myElements[c].outerHTML);
                    if (myElements[c].tagName == 'P'){
                        //// $(myViewer).find(`#${part>0?`${part}_`:''}${myCueId}`).append( $(myElements[c]).clone() )
                        $(myViewer).find(`#${part}_${myCueId}`).append( $(myElements[c]).clone() )
                    }else{ //if (myElements[c].tagName == 'SPAN'){
                        //// $(myViewer).find(`#${part>0?`${part}_`:''}${myCueId}`).append(`<p class="${myElements[c].className}">${myElements[c].outerHTML}</p>` )
                        $(myViewer).find(`#${part}_${myCueId}`).append(`<p class="${myElements[c].className}">${myElements[c].outerHTML}</p>` )
                    }
                }
                // reset range
                a=b+1;
                // has more elements then add next cue with id
                if (a<myElements.length){
                    myCueId++;
                    //// $(myViewer).append(`<div class="cue" id="${part>0?`${part}_`:''}${myCueId}"></div>`);
                    $(myViewer).append(`<div class="cue" id="${part}_${myCueId}" style="z-index:-${myCueId}"></div>`);
                }
            }
        }
        // return html
        return myViewer[0].innerHTML
        // return myViewer[0].outerHTML // creates #Viewer in #Viewer 2021-11-15
        console.log( myViewer[0].outerHTML )
        }
    async function sendCue(cue){
        var params = {
            //   cid : 'a718-jjhw-9abe-rje6-4f2b',
            //   cid : 'a912-s65v-6u54-83mb-8mup',
            //   cid : 'te13-hqqs-09jg-7pxg',
              cid : '0v4b-jjmv-7jf8-gzqz-e6hq', //Tulku Ajam Rinpoche New Live stream key
              seq : new Date().getTime(),
            //   id : '',
            //   ns : ''
            }
        var yturl = `https://upload.youtube.com/closedcaption?${Object.keys(params).map(param=>`${param}=${params[param]}`).join('&')}`
        var body = `${new Date(Date.now()).toISOString().slice(0,-1)} \n${$(cue).find('p[class^="tib"]').text()}\n`
        console.log(yturl)
        console.log(body)
        await fetch( 'https://tulkuajam.org:8089/'+yturl, {  // mode: 'no-cors',
            method: 'POST',
            headers: {'Content-Type': 'text/plain'},
            body: body
        })
        .then(response => response.text())
        .then(data => {
            console.log('Success:', new Date( data.trim()+"Z").toLocaleString(undefined,{hour12:false}) );
        })
        .catch((error) => {console.error('Error:', error); });
     }

    function registerCues(html){
        console.log('registerCues',window.player)
        // follow link
        socket8753.emit('msgId', $(html).attr('id') )
        // register cues firebase link
        console.log('register cues firebase link')
        fb.database().ref(`EasyViewer5/cues`).push({timestamp: new Date().getTime(), html: html})
        // http post captions
        // sendCue(html)

     }
    function setScroller(on){
        if (on == false){
            $(cueList$[cuePosition]).css('background-color','')
            $('body').off('keydown').off('click')
            $('#Viewer').off('wheel')
            return false
        }
        // console.log('setScroller',new YouTubePlayer('#videoiFrame'))
        // else on true
        cueList$ = $('.cue').has('[class^="tibText"], [class^="tibMantra"]')
        cuePosition = 0;
        registerCues(cueList$[cuePosition].outerHTML)
        $(cueList$[cuePosition]).css('background-color','#9eff02ed')

        // scrollIntoViewOptions Optional
            // Is an Object with the following properties:
            // behavior Optional, // Defines the transition animation. One of "auto" or "smooth". Defaults to "auto".
            // block Optional,    // Defines vertical alignment. One of "start", "center", "end", or "nearest". Defaults to "start".
            // inline Optional,   // Defines horizontal alignment. One of "start", "center", "end", or "nearest". Defaults to "nearest".
        cueList$[cuePosition].scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
        if ($('#navbarNavbar').css('display') == 'block'){ $('#output, #Viewer').trigger('click') }

        $('body')
        .off('keydown')
        .on('keydown',function(e){ console.log(e)
            if ($('#navbarNavbar').css('display') == 'block'){ $('#output, #Viewer').trigger('click') }
            // 40 down arrow: move next
            if (e.which==40){ console.log('keydown down')
                e.preventDefault()
                // reset color
                if (cuePositionBookmark==cuePosition){
                    $(cueList$[cuePosition]).css('background-color','#72fa5d5c')
                }else{
                    $(cueList$[cuePosition]).css('background-color','')
                }
                // move down
                if(cuePosition < cueList$.length-1){ cuePosition++ }

                registerCues(cueList$[cuePosition].outerHTML)
                $(cueList$[cuePosition]).css('background-color','#9eff02ed')

                // scroll to
                if(! isElementInViewport(cueList$[cuePosition]) ){
                    cueList$[cuePosition].scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
                }
            // 38 up arrow: move previous
            }else if (e.which==38){ console.log('keydown up')
                e.preventDefault()
                $(cueList$[cuePosition]).css('background-color','')
                if (cuePosition>0){ cuePosition-- }
                registerCues(cueList$[cuePosition].outerHTML)
                $(cueList$[cuePosition]).css('background-color','#9eff02ed')
                if(! isElementInViewport(cueList$[cuePosition]) ){
                    cueList$[cuePosition].scrollIntoView({ behavior: 'auto', block: 'end', inline: 'center' });
                }
            // 32 spacebar: mark cue
            }else if (e.which==32){ console.log('keydown space')
                e.preventDefault()
                // mark present position
                console.log('Bookmark cuePosition')
                if (cuePositionBookmark!=undefined){ $(cueList$[ cuePositionBookmark ]).css('background-color','') }
                cuePositionBookmark = cuePosition
                $(cueList$[ cuePositionBookmark ]).css('background-color','#72fa5d5c')
            // 37 left arrow: move to marked cue
            }else if (e.which==37){ console.log('keydown <<')
                e.preventDefault()
                if (cuePositionBookmark!=undefined){
                    $(cueList$[cuePosition]).css('background-color','')
                    cuePosition = cuePositionBookmark;
                    registerCues(cueList$[cuePosition].outerHTML)
                    $(cueList$[cuePosition]).css('background-color','#9eff02ed')
                    if(! isElementInViewport(cueList$[cuePosition]) ){
                        cueList$[cuePosition].scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
                    }
                }
            // 39 left arrow: move to marked cue
            }else if (e.which==39){ console.log('keydown right')
            e.preventDefault()
            // mark present position
                console.log('Bookmark cuePosition')
                if (cuePositionBookmark!=undefined){ $(cueList$[ cuePositionBookmark ]).css('background-color','') }
                cuePositionBookmark = cuePosition
                $(cueList$[ cuePositionBookmark ]).css('background-color','#72fa5d5c')

            // move down
                // $(cueList$[cuePosition]).css('background-color','')
                if(cuePosition < cueList$.length-1){ cuePosition++ }
                registerCues(cueList$[cuePosition].outerHTML)
                $(cueList$[cuePosition]).css('background-color','#9eff02ed')
                if(! isElementInViewport(cueList$[cuePosition]) ){
                    cueList$[cuePosition].scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
                }
            }
         })
        .off('click','.cue')
        .on('click','.cue',function(e){ //console.log(  e.target )
            e.preventDefault()
            $(cueList$[ cuePosition ]).css('background-color','')
            cuePosition = $(cueList$).index($(e.target).parents('.cue'))
            registerCues(cueList$[cuePosition].outerHTML)
            $(cueList$[ cuePosition ]).css('background-color','#9eff02ed')
         });
        $('#Viewer')
        .off('wheel')
        .on('wheel',function(e){
            e.preventDefault()
            if ( e.originalEvent.deltaY>0 ){
                var e = $.Event('keydown');
                e.which= 40;
                $('body').trigger(e);
            }else{
                var e = $.Event('keydown');
                e.which= 38;
                $('body').trigger(e);
            }

         })
        }

    async function setPrayer(path,prayers) {
        $('#Viewer').html('<div class="lds-spinner center"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>')
        var myhtml = ""
        prayers = prayers.split(";")
        // prayers = prayers[0]
        for (var a=0;a<prayers.length;a++){
            var prayer = prayers[a];
            var html="";
            if (/.docx$/.test(prayer)) {
                console.log('loading...',a,prayer)
                // 1. use loadDocx to get html
                html = await loadDocx(`${path}/${prayer}`)
                html = addCues(html,a,prayer)

            }else{
                var data = await fetch(`${path}/${prayer}`) //, function (data) {
                data = await data.text();
                console.log(data);
                if (/.html$/.test(prayer)) {
                    // 2. use raw html
                    html = data;
                    html = htmlNormalize(html)
                } else if (/.json$/.test(prayer)) {
                    // 3. parse json to html
                    data = JSON.parse(data);
                    var innerTemplate = "{{#text}}<{{tag}} {{#class}}class='{{class}}'{{/class}}  {{#textId}}id='{{textId}}'{{/textId}}  {{#href}}href='{{href}}'{{/href}}>{{{html}}}</{{tag}}>{{/text}}";
                    var template = "{{#myData}}<{{tag}} {{#class}}class='{{class}}'{{/class}}  {{#id}}id='{{id}}'{{/id}}  {{#href}}href='{{href}}'{{/href}}>" + innerTemplate + "</{{tag}}>{{/myData}}";
                    var html = Mustache.render(template, data);
                    html = htmlNormalize(html)
                }else{
                    html="";
                }
            }
            myhtml += html
        }
        ///console.log($(myhtml)[0].outerHTML)

        $('#Viewer').html(myhtml);
        console.log(`486 $('#Viewer').html(myhtml);`)
        // $('.lds-spinner').remove()
        // console.log({myhtml})
        // $('title').text(data.name);
        // $("html, body").animate({ scrollTop: 0 }, "slow");
        // setScroller()

        addRepeatLinks()
        // get all filenames
        let filenames= $('#Viewer').find('.cue[data-file]').toArray().map(m=>m.getAttribute('data-file'));console.log('filenames',filenames)
        async function postData(paraId, text, force) {
            const url = 'https://server.tulkuajam.org/webui/maryV1';
            const body = { paraId, text, force };
            // console.log('Sending data:', body);
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body)
                });

                // Check if the response was successful (status code 200-299).
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const responseData = await response.json();
                // console.log(JSON.stringify(responseData,null,4));
                // console.log(responseData.content)
                return responseData
            } catch (error) {
                console.error('Error:', error);
            }
          }
        async function postDataV2(filename,paraId, text, force) {
            const url = 'https://server.tulkuajam.org/webui/maryV1';
            const body = {filename, paraId, text, force };
            // console.log('Sending data:', body);
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body)
                });

                // Check if the response was successful (status code 200-299).
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const responseData = await response.json();
                // console.log(JSON.stringify(responseData,null,4));
                // console.log(responseData.content)
                return responseData
            } catch (error) {
                console.error('Error:', error);
            }
          }
        function createMyElement(cue,pClass,spanClass,text) {
            // const pClass = "tibTextP";
            // const spanClass = "tibTextA";
            // const tibetanText = "༄༅། དགོངས་གཏེར་སྒྲོལ་མའི་ཟབ་ཏིག་ལས། ལེགས་སོ་གསུམ་གྱི་དོན་ཁྲིད་གསལ་བར་བཀོད་པ་";

            const pElement = document.createElement("p");
            pElement.setAttribute("class", pClass);
            pElement.setAttribute("contenteditable","");

            const spanElement = document.createElement("span");
            spanElement.setAttribute("class", spanClass);

            const textNode = document.createTextNode(text);
            spanElement.appendChild(textNode);

            pElement.appendChild(spanElement);

            cue.appendChild(pElement);
            }
        async function translateCue(cue,force=false){
            // if($(cue).find('.chinMeanP').length>0){
            //     console.log('already found',$(cue).find('.chinMeanP')[0])
            //     return
            // }
            let P$ = $(cue).find('p').first()
            let paraId    = P$.attr('paraId')
            let tib       = P$.text().trim()
            let pClass    = P$.attr('class')
            console.log(paraId,pClass,tib)
            if(!paraId || tib=='' || pClass.indexOf("Sabched")>-1) return

            // check localStorage for text
            let savedContent = localStorage.getItem(`${paraId}_${pClass}`);

            let response = await postData(paraId,tib,force)
            if(response?.content.match(/Error:/)){
                console.log('translation error',response.content)
                return
            }
            let ps = response.content.split('\n\n').map(m=>m.split('\n'))
            console.log(ps);

            let data = {}
            for(let a=0;a<ps.length;a++){
                // console.log(ps[a])
                for(let b=0;b<ps[a].length;b++){
                    let temp = ps[a][b]; console.log(temp)
                    let pClass = temp.split('|')[0]
                    let trans  = temp.split('|')[1]
                    data[pClass] = data[pClass]==undefined?data[pClass]="":data[pClass]
                    data[pClass]+=" "+trans
                }
             }
            // console.log(data)
            for(let tran of ['chinMean','engMean','gerMean']){
                // check localStorage for text
                let savedContent = localStorage.getItem(`${paraId}_${tran+"P"}`);
                createMyElement(cue,tran+"P",tran+"A",savedContent || data[tran])
             }
          }
        async function EasyViewer5TranslateCue(cue,force=false){
            let id_ = cue.id.split('_')[0]; // get filename id_
            let filename = filenames[id_]; // set filename
            console.log('filename',filename)
            let P$ = $(cue).find('p').first()
            let paraId    = P$.attr('paraId')
            let tib       = P$.text().trim()
            let pClass    = P$.attr('class')
            console.log(paraId,pClass,tib)
            if(!paraId || tib=='' || pClass.indexOf("Sabched")>-1){
                console.error('No paraId or empty tibetan text or Sabched found')
                 return
            }

            // check localStorage for text
            let savedContent = localStorage.getItem(`${paraId}_${pClass}`);

            let response = await postData(paraId,tib,force) //postDataV2(filename,paraId,tib,force)
            if(response?.content.match(/Error:/)){
                console.log('translation error',response.content)
                return
            }
            let ps = response.content.split('\n\n').map(m=>m.split('\n'))
            console.log(ps);

            let data = {}
            for(let a=0;a<ps.length;a++){
                // console.log(ps[a])
                for(let b=0;b<ps[a].length;b++){
                    let temp = ps[a][b]; console.log(temp)
                    let pClass = temp.split('|')[0]
                    let trans  = temp.split('|')[1]
                    data[pClass] = data[pClass]==undefined?data[pClass]="":data[pClass]
                    data[pClass]+=" "+trans
                }
             }
            // console.log(data)
            for(let tran of ['chinMean','engMean','gerMean']){
                // check localStorage for text
                let savedContent = localStorage.getItem(`${paraId}_${tran+"P"}`);
                createMyElement(cue,tran+"P",tran+"A",savedContent || data[tran])
             }
          }


        async function EasyViewer5TranslateAllCues(){


            // get all cues and translate
            let cues =
                // $('.cue')
                $('.cue') //.has('.tibTextP')
                .toArray()
            console.log(cues.length)
            cues = cues
            // .slice(0,134) // 134 legso dangpo
            .slice(0,1)
            for(let cue of cues){
                console.log(cue)
                // // ignore if .chimMeanP found
                // if ($(cue).find('p[class^="tib"]').nextAll('.chinMeanP').length > 0) return
                await EasyViewer5TranslateCue(cue)
            }
        }
        window.EasyViewer5TranslateAllCues = EasyViewer5TranslateAllCues;
        console.log('EasyViewer5TranslateAllCues')

      }

    async function loadDocx(docx) {
        var myHeaders = new Headers([
            ['pragma', 'no-cache'],
            ['cache-control', 'no-cache, no-store, must-revalidate'], // force the browser to check the server to see if the file is different from the file it already has in the cache.
            ['Expires','0']
          ])
        try{
            var temp = await fetch(docx,{headers:myHeaders})
            var result  = await temp.arrayBuffer()
        }catch(error){
            console.log('error',error)
        }finally{
            //Code to be executed at the end of all statements is written here
            //console.log('loaded.')
        }
        // console.log(result);
        var z = new JSZip(result);
        window.z=z

        // 2018-08-15
        //**** output style **************************************************************
            var xmlStyleStr = z.file("word/styles.xml").asText()
            xmlStyleStr = xmlStyleStr.replace(/[a-zA-Z0-9]+:/g,'') // remove namespace xx:
            // xmlStyleStr = xmlStyleStr.split(/w:/g).join('')
            var xmlStyle = $.parseXML(xmlStyleStr)
            var styleJson = xmlToJson(xmlStyle)
            //******************************************************************
        // 2018-08-15
        // get default for pPr and rPr
            var defaultpPr = styleJson.styles.docDefaults.pPrDefault.pPr || defaultpPr || {}
            var defaultrPr = styleJson.styles.docDefaults.rPrDefault.rPr || defaultrPr || {}

        // 2021-06-25
        //***** get rels *********************************************************************
            var xmlRelsStr = z.file("word/_rels/document.xml.rels").asText()
            xmlRelsStr = xmlRelsStr.replace(/[a-zA-Z0-9]+:/g,'') // remove namespace xx:
            var xmlRels = $.parseXML(xmlRelsStr)
            //console.log('xmlRels',xmlRels)
            var temp = $(xmlRels).find('Relationship[Id="rId6"]'),temp=temp?temp[0]:temp
            //console.log( $(temp).getAttributes())
            window.getrId = function(rId){
                var temp = $(xmlRels).find(`Relationship[Id="${rId}"]`)
                return temp?temp[0]:temp
            }
        //***** output docx ******************************************************************
            var xmlStr = z.file("word/document.xml").asText()
            // xmlStr = xmlStr.replace(/[a-zA-Z0-9]+:/g,'') // remove namespace xx: //2026-06-20
            xmlStr = xmlStr.replace(/(<\/?|\s)([a-zA-Z0-9]+):/g, '$1'); // saver only <wp: xxx
            // xmlStr = xmlStr.split(/w:/g).join('')
            // console.log('xmlStr  ',xmlStr)
            var xml = $.parseXML(xmlStr)
            console.log('xml  ',xml)
            var newHtml = wF.main(xml)
            // console.log('main',performance.now()-InterVal1); InterVal1 = performance.now()

        // *** sort styleJson ***
            styleJson.styles.style.sort(function(a,b){
                return (
                    a.name.attributes.val < b.name.attributes.val ?-1:
                        a.name.attributes.val > b.name.attributes.val ? 1 :
                            0)
            })
            // console.log('styleJson sorted',styleJson)
            // *** sort styleJson ***

        // *** filter msword styles ***
            styleJson.styles.style = styleJson.styles.style.filter(function(f){
                return StyleList[f.attributes.styleId]
            })
            // console.log('filter only used styles',styleJson.styles.style)

        // *** apply styles
            styleJson.styles.style.forEach(function(s,i,arr){
                arr[i].pPr = Object.assign({},defaultpPr, s.pPr)
                arr[i].rPr = Object.assign({},defaultrPr, s.rPr)
            })
            // console.log('pPr = pPrDefault+pPr and rPr = rPrDefault+rPr', styleJson)

        // *** make css style from styleJson
            // var html = styleJsonToCss2(styleJson)

        //**** output style **************************************************************
            // $('#outputstyle').html(html)
            // console.log('parse Style', performance.now()-InterVal1); InterVal1 = performance.now()

        // $('#output').html(newHtml)
        // window.scrollTo(0,y)
        // console.log('full', performance.now()-startVal1)
        return newHtml;
        }

    function setTibetanFont(tibetanFontname){
        bNavbar.setStyleAll('p[class^="tib"]','fontFamily',tibetanFontname)
        }
    function setFollow(on){ console.log('Follow')
        if (on == true){
            loadSocket('https://tulkuajam.org:8753');
            window.cueList = [];
            window.cueDelay = 0;
            socket8753.on('msgId', function(msg){
                setTimeout(function(){
                    $(`#${window.lastMsg}`).css('background-color','')
                    console.log(msg,Date.now(),window.cueDelay)
                    window.cueList[msg] = Date.now()
                    $(`#${msg}`).css('background-color','#9eff02ed')
                    // scroll to
                    if (window.followPage){
                        if(! window.isElementInViewport( $(`#${msg}`)[0] )){
                            $(`#${msg}`)[0].scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
                        }
                    }
                    window.lastMsg = msg;
                },cueDelay)
            });

            $('body').on('click','.cue',function(e){
                console.log(
                    $(e.target).parents('.cue').attr('id'),
                    Date.now() - window.cueList[$(e.target).parents('.cue').attr('id')]
                )
                var lasttime = window.cueList[$(e.target).parents('.cue').attr('id')]
                if (lasttime){
                    window.cueDelay = Date.now() - lasttime
                    console.log(window.cueDelay)
                }

            })
        }else{
            socket8753.disconnect(true)
            $('body').off('click','.cue')
        }
     }
    function viewport(){
        this.x = window.pageXOffset ;
        this.w = window.innerWidth ;
        this.x2 = this.x + this.w - 1 ;
        this.y = window.pageYOffset ;
        this.h = window.innerHeight ;
        this.y2 = this.y + this.h - 1 ;
        return this ;
     }
    function isVisible( element){ //, vp ){
        /* This checks if the element is in the viewport area, you could also
        * check the display and visibility of its style.
        */
        if(element==undefined) return false
        var vp = new viewport( ) ;
        var rect = element.getBoundingClientRect( ) ;
        var x = rect.left ;
        var x2 = x + element.offsetWidth ;
        var y = rect.top ;
        var y2 = y + element.offsetHeight ;
        return !( x >= vp.w || y >= vp.h || x2 < 0 || y2 < 0 ) ;
     }
    function addRepeatLinks(){
        var repeatLinks = $('div.cue:has(p.tibRepeatLinkP)');
        //console.log(repeatLinks)
        repeatLinks.each((i,el)=>{ //console.log(i,el)
            var target = $(el).find('a').attr('href');
            var times  = $(el).find('a')[0].className.match(/\d+/)?$(el).find('a')[0].className.match(/\d+/)[0]*1:'x';
            var time   = 1;
            $(el).attr('data-target',target)
            $(el).attr('data-times',times)
            $(el).attr('data-time',time)
        })
        var gotoLinks = $('div.cue:has(p.tibGotoP)');
        gotoLinks.each((i,el)=>{ //console.log(i,el)
            var target = $(el).find('a').attr('href');

            $(el).attr('data-target',target)
        })
        $('#Viewer span[id]').css({
            color: "red"
        })
     }
    function wrapSelectedText() {
        // get selection
        var selection = window.getSelection().getRangeAt(0); console.log(selection)
        // get selection text
        var selectedText = selection.extractContents();
        // next ping
        if(selection.startContainer.parentElement.tagName.substr(0,"PING".length)=="PING"){

        }
        // create wrapper element
        var span= document.createElement("ping1");
        // with style yellow
        span.style.backgroundColor = "yellow";
        // add text to span
        span.appendChild(selectedText);

        selection.insertNode(span);
     }
    function togglePing1_6(){
        var selection = window.getSelection(); // get selection
        var selection_text = selection.toString(); // get text of selection
        if (selection_text != "") { // only if text is selected
            var range = selection.getRangeAt(0); // get selection range
            if(selection_text.length>1){
                //alert('select only one character at a time');
                selection.removeAllRanges();
                return false
            }
            var elRes = selection.baseNode.parentNode.nodeName // get "baseNode.parentNode.nodeName" of selection
            if (elRes.substr(0,4) == 'PING'){  // if name is PINGx
                     if(elRes == 'PING1') {elRes = 'PING2'}
                else if(elRes == 'PING2') {elRes = 'PING3'}
                else if(elRes == 'PING3') {elRes = 'PING4'}
                else if(elRes == 'PING4') {elRes = 'PING5'}
                else if(elRes == 'PING5') {elRes = 'PING6'}
                else if(elRes == 'PING6') {elRes = 'PING1'}
            }else{
                elRes = "PING1"
            }
            var ping = document.createElement(elRes); // make "pingx" element
            ping.textContent = selection_text; // add text to element
            // delete old element
            if (/^#text/i.test(selection.baseNode.nodeName)){ // baseNode "#text"
                if(/^ping/i.test(selection.baseNode.parentNode.nodeName)){ // parentNode "Ping"
                    range.selectNode(selection.baseNode.parentNode) // select parentNode
                }
            }else{
                console.log('#text not selected node')
            }
            range.deleteContents() // remove selected node
            // add new element
            range.insertNode(ping)
            // for next toggle
            // select text of new element
            range.selectNodeContents(ping) // select text node
            range.selectNodeContents(selection.baseNode.firstChild) // select text
            console.log(selection.baseNode.parentNode.nodeName)
        }// do nothing if no text selected
     }
    function enableChinEdit(yesNo){
        if(yesNo){
            $('body').on('pointerup', '#output, #Viewer ',function(e){
                togglePing1_6()
            })
        }else{
            $('body').off('pointerup', '#output, #Viewer')
        }
     }
    // add counter number to repeat button
    function updatePseudoCounters() {
        const allCues = Array.from(document.querySelectorAll('.cue'));
        const targetedCues = document.querySelectorAll('.cue[data-target]');

        targetedCues.forEach(container => {
            const targetHash = container.getAttribute('data-target');

            // Use querySelectorAll to get EVERY hyperlink in this cue container
            const links = container.querySelectorAll('a.Hyperlink');

            if (targetHash && links.length > 0) {
                const targetId = targetHash.substring(1);
                const targetEl = document.getElementById(targetId);

                if (targetEl) {
                    const targetCue = targetEl.closest('.cue');

                    if (targetCue) {
                        // Calculate the nth position (or use targetCue.id.split('_')[1] if preferred)
                        const nthIndex = allCues.indexOf(targetCue) + 1;

                        // Loop through all the language buttons and set the data attribute
                        links.forEach(link => {
                            link.setAttribute('data-target-nth', nthIndex);
                        });
                    }
                }
            }
        });
    }
    //  enableChinEdit(true)
// navbar dropdowns menus
    bNavbar.addBootstrapNavbar(navBar);
    // 1) brand
        bNavbar.changeNavbarBrand(
            bNavbar.createSpanObj([
                {tib:'དཔེ་མཛོད།'},
                {chin:'書室'},
                {eng:'EasyViewer5'}
            ]));
    // display menu
      // Display Dropdown Menu functions
        function menuClick(key){
            console.log('115',key)
            var setting = window.EVdefault.Language[key]||EVdefaultSettings.Language[key]||false;
            console.log('menuClick',setting)
            if (setting){
                var display = setting.display || ''
                if (display == 'block' || display==""){
                    setting.display = 'none'
                }else{
                    setting.display = 'block'
                }
                bNavbar.setStyleAll(setting.getSelector, 'display', setting.display)

                if (setting.display=='block'){
                    $(`#${key} span[class*="glyphicon"]:nth-child(1)`).removeClass('glyphicon-remove').addClass('glyphicon-ok')
                    appendParam('lang',key)
                }else{
                    $(`#${key} span[class*="glyphicon"]:nth-child(1)`).removeClass('glyphicon-ok').addClass('glyphicon-remove')
                    removeParam('lang',key)
                }
                window.EVdefault.Language[key] = setting;
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            }
         }
        function menuSoloClick(lang,noneList){
            var Language = window.EVdefault.Language||EVdefaultSettings.Language||false; //console.log(Language)
            if (Language){
                Object.keys(Language).map((key,i)=>{ //console.log('116',Language,i,key)
                    if(key!='ChinesePinYing'){
                        var setting = Language[key];
                        if(key == lang){ setting.display = "block" }
                        if(noneList.indexOf(key)>-1){ setting.display = "none" } //console.log(setting)
                        bNavbar.setStyleAll(setting.getSelector, 'display', setting.display)

                        // var addclass = setting.display=='block'?'glyphicon-ok':'glyphicon-remove';
                        // $(`#${key} span[class*="glyphicon"]:nth-child(1)`).removeClass('glyphicon-remove glyphicon-ok').addClass(addclass)
                        if (setting.display=='block'){
                            $(`#${key} span[class*="glyphicon"]:nth-child(1)`).removeClass('glyphicon-remove').addClass('glyphicon-ok')
                            appendParam('lang',key)
                        }else{
                            $(`#${key} span[class*="glyphicon"]:nth-child(1)`).removeClass('glyphicon-ok').addClass('glyphicon-remove')
                            removeParam('lang',key)
                        }
                        window.EVdefault.Language[key] = setting;
                    }
                })
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            }
         }
        function buttonPlusMinus(lang,changeValue){ console.log(lang,changeValue)
            var setting = window.EVdefault.Language[lang]
            var fs = (parseFloat( bNavbar.getCSSRule(setting.getSelector)['style']['fontSize'] ) + changeValue).toFixed(1)

            bNavbar.setStyleAll(setting.getSelector,'font-size',`${fs}em`); console.log(setting.getSelector,fs)

            setting.fontSize = `${fs}em`
            localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
         }
        function setPageRangex(onOff){
            if(onOff){
                if($('#pageRange').length<1){
                    $('#navbarCenter').prepend(
                        ``
                        +`<li><a href="#"><div id="xxpageRange"><span id="startPage">1</span>-<span id="endPage">2</span> </div></a></li>`
                        +`<ul id="navLinks" class="nav" hidden></ul>`
                    )
                    var cues = $('#Viewer>.cue'); console.log(cues.length);
                    for(var c=0;c<cues.length;c++){
                        $('#navLinks').append(`<li><a href="#${cues[c].id}">${c}</a></li>`)
                    }
                    $('#Viewer').data('spy','scroll').data('target','.navbar')
                    $('#Viewer').scrollspy({ target: '.navbar' })
                    $('#navbarCenter').on('activate.bs.scrollspy',function(e){
                        // console.log($(e.target).find('a').attr('href'))
                        // get scrollspy page id
                            var temp = e.target.getElementsByTagName('a')
                            var pageNo = temp.item(temp.length - 1).hash.replace('#','')
                            console.log(pageNo)
                        // check forward
                            // for(var n=0;n<100;n++){
                            //     if( isVisible($('#'+(pageNo-n))[0])==false ) break;
                            // }
                            // var startPage = pageNo-n+1
                            // console.log(startPage)
                            var next = $('#'+(pageNo))[0].nextElementSibling
                            while(isVisible(next)){
                                next = next.nextElementSibling
                            }
                            console.log(next.previousElementSibling)
                        // check backward
                            // for(var n=0;n<100;n++){
                            //     if( isVisible($('#'+(pageNo+n))[0])==false ) break;
                            // }
                            // var endPage = pageNo+n-1
                            // console.log(endPage)
                            var previous = $('#'+(pageNo))[0].previousElementSibling
                            while(isVisible(previous)){
                                previous = previous.previousElementSibling
                            }
                            console.log(previous.nextElementSibling)
                        // update start and end page
                            $('#startPage').text(next.previousElementSibling.id)
                            $('#endPage').text(previous.nextElementSibling.id)
                    })
                }
            }else{
                if($('#pageRange').length>0){
                    $('#pageRange').remove()
                    $('#navbarCenter').off('activate.bs.scrollspy')
                }
            }
         }
      // Display Menu's
        var tibetanMenu = {
            id:'Tibetan', text:[{tib:'བོད་སྐད།', title:"བོད་སྐད།"},{chin:'藏文'},{eng:'Tibetan'}],
            className:'Menu', glyphicon:'ok',
            buttons:{
                py: {
                    id: "Asterisk",
                    class:"glyphicon glyphicon-asterisk Asterisk",
                    style: "float:right;",
                    text: "&nbsp;",
                    clickFunction: function(e){ console.log(e,event)
                        event.stopPropagation()
                        menuSoloClick('Tibetan',['Chinese','English','German'])
                    }
                },
                minus:{
                    id: "Minus",
                    class:"glyphicon glyphicon-minus minus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('Tibetan',-0.1)
                    }
                },
                plus:{
                    id: "Plus",
                    class:"glyphicon glyphicon-plus plus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('Tibetan',+0.1)
                    }
                }
            },
            clickFunction: function(e){
                event.stopPropagation()
                menuClick('Tibetan')
            }
         }
        var chineseMenu = {
            id:'Chinese',text:[{tib:'རྒྱ་སྐད།'},{chin:'中文'},{eng:'Chinese'}],
            className:'Menu', glyphicon:'ok',
            buttons:{
                py: {
                    id: "Asterisk",
                    class:"glyphicon glyphicon-asterisk Asterisk",
                    style: "float:right;",
                    text: "&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        menuSoloClick('Chinese',['English','German'])
                    }
                },
                minus:{
                    id:'Minus',
                    class:"glyphicon glyphicon-minus minus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('Chinese',-0.1)
                    }
                },
                plus:{
                    id: 'Plus',
                    class:"glyphicon glyphicon-plus plus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('Chinese',+0.1)
                    }
                }
            },
            clickFunction: function(e){
                event.stopPropagation()
                menuClick('Chinese')
            }
         }
        var tibetanPingYingMenu = {
            id:'TibetanPingYing',text:[{tib:'བོད་སྐད་སྒྲ་གདངས།'},{chin:'藏文拼音'},{eng:'TibetanPingYin'}],
            className:'Menu', glyphicon:'ok',
            clickFunction: function(e){
                event.preventDefault()
                event.stopPropagation()
                bNavbar.toggleStyles(e,'p[class^="chinTrans"]','display','','none')
                window.EVdefault.settings.TibetanPingYing = $('#Viewer p[class^="chinTrans"]').css('display')
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            }
         }

        var ChinesePinYingMenu = {
            id:'ChinesePinYing',text:[{tib:'རྒྱ་སྐད་ཕིན་དབྱིངས།'},{chin:'中文拼音'},{eng:'Chinese PinYin'}],
            className:'Menu', glyphicon:'remove',
            clickFunction: function(e){ console.log(e)
                event.preventDefault()
                event.stopPropagation()
                bNavbar.toggleMe2(e,
                    function(){
                        bNavbar.setStyleAll('p[class^="chin"]','fontFamily','StdKaiXHYL1EG-Md',cachedStyles)
                        bNavbar.setStyle('ping1 span.ping1 span[class$="Ping1"]','fontFamily', 'StdKaiXHYL1EG-Md',cachedStyles)
                        bNavbar.setStyle('ping2 span.ping2 span[class$="Ping2"]','fontFamily', 'StdKaiXHYL2EG-Md',cachedStyles)
                        bNavbar.setStyle('ping3 span.ping3 span[class$="Ping3"]','fontFamily', 'StdKaiXHYL3EG-Md',cachedStyles)
                        bNavbar.setStyle('ping4 span.ping4 span[class$="Ping4"]','fontFamily', 'StdKaiXHYL4EG-Md',cachedStyles)
                        bNavbar.setStyle('ping5 span.ping5 span[class$="Ping5"]','fontFamily', 'StdKaiXHYL5EG-Md',cachedStyles)
                        bNavbar.setStyle('ping6 span.ping6 span[class$="Ping6"]','fontFamily', 'StdKaiXHYL6EG-Md',cachedStyles)
                        window.EVdefault.Language.Chinese.pinying = "pin-ying-on"
                    },
                    function(){
                        bNavbar.setStyleAll('p[class^="chin"] ping1 span.ping1 span[class$="Ping1"] ping2 span.ping2 span[class$="Ping2"] ping3 span.ping3 span[class$="Ping3"] ping4 span.ping4 span[class$="Ping4"] ping5 span.ping5 span[class$="Ping5"] ping6 span.ping6 span[class$="Ping6"]','fontFamily','DFKai-SB',cachedStyles)
                        window.EVdefault.Language.Chinese.pinying = "pin-ying-off"
                    }
                )
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            }
         }
        var englishMenu = {
            id:'English',text:[{tib:'ཨིང་སྐད།'},{chin:'英文'},{eng:'English'}],
            className:'Menu', glyphicon:'ok',
            buttons:{
                py: {
                    id: 'asterisk',
                    class:"glyphicon glyphicon-asterisk",
                    style: "float:right;",
                    text: "&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        menuSoloClick('English',['Chinese','German'])
                    }
                },
                minus:{
                    id: 'Minus',
                    class:"glyphicon glyphicon-minus minus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('English',-0.1)
                    }
                },
                plus:{
                    id: 'Plus',
                    class:"glyphicon glyphicon-plus plus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('English',+0.1)
                    }
                }
            },
            clickFunction: function(e){
                event.stopPropagation()
                menuClick('English')
            }
         }
        var germanMenu = {
            id:'German',text:[{tib:'རྒྱ་མན་སྐད།'},{chin:'德文'},{eng:'German'}],
            className:'Menu', glyphicon:'ok',
            buttons:{
                py: {
                    id: "Asterisk",
                    class:"glyphicon glyphicon-asterisk Asterisk",
                    style: "float:right;",
                    text: "&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        menuSoloClick('German',['Chinese','English'])
                    }
                },
                minus:{
                    id: "Minus",
                    class:"glyphicon glyphicon-minus minus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('German',-0.1)
                    }
                },
                plus:{
                    id: "Plus",
                    class:"glyphicon glyphicon-plus plus",
                    style: "float:right;",
                    text: "&nbsp;&nbsp;",
                    clickFunction: function(e){ //console.log(e)
                        event.stopPropagation()
                        buttonPlusMinus('German',+0.1)
                    }
                }
            },
            clickFunction: function(e){
                event.stopPropagation()
                menuClick('German')
            }
         }
        var ScrollerMenu = {
            id:'ScrollerOnOff',text:[{tib:'Scroller'},{chin:'Scroller'},{eng:'Scroller'}],
            className:'Menu',glyphicon:'remove',
            // glyphicon:'star',
            clickFunction: function(e){
                bNavbar.toggleMe2(e,
                    function(){
                        setScroller(true)
                    },function(){
                        setScroller(false)
                    }
                )
            }
         }
        var EnablePageRange = {
            id:'EnablePageRangeOnOff',text:[{tib:'EnablePageRange'},{chin:'EnablePageRange'},{eng:'EnablePageRange'}],
            className:'Menu',glyphicon:'remove',
            // glyphicon:'star',
            clickFunction: function(e){
                bNavbar.toggleMe2(e,
                    function(){ console.log('on','EnablePageRange')
                        setPageRangex(true)
                    },function(){ console.log('off','EnablePageRange')
                        setPageRangex(false)
                    }
                )
            }
         }
        var FollowMenu = {
            id:'FollowOnOff',text:[{tib:'Follow'},{chin:'Follow'},{eng:'Follow'}],
            className:'Menu',glyphicon:'remove',
            // glyphicon:'star',
            clickFunction: function(e){
                bNavbar.toggleMe2(e,
                    function(){
                        setFollow(true)
                    },function(){
                        setFollow(false)
                    })
            }
         }

        var FollowPage = {
            id:'FollowPageOnOff',text:[{tib:'Follow Page'},{chin:'Follow Page'},{eng:'Follow Page'}],
            className:'Menu',glyphicon:'remove',
            // glyphicon:'star',
            clickFunction: function(e){
                bNavbar.toggleMe2(e,
                    function(){
                        window.followPage = true
                    },function(){
                        window.followPage = false
                    })
            }
         }
        var FollowDelay = {
            id:'FollowDelayOnOff',text:[{tib:'Follow Delay:'},{chin:'Follow Delay:'},{eng:'Follow Delay:'}],
            className:'Menu', glyphicon:'none',
            // glyphicon:'star',
            // clickFunction: function(e){
            //     bNavbar.toggleMe2(e,
            //         function(){
            //             window.followPage = true
            //         },function(){
            //             window.followPage = false
            //         })
            // }
         }
        var TranslateChinMenu ={
            id: 'TransliterateChin',
            text: [{tib:'Transliterate Chinese'},{chin:'Transliterate Chinese'},{eng:'Transliterate Chinese'}],
            glyphicon:'star',
            clickFunction: function(me){
                console.log(me)
                transliterate("C001")
                return
                var TransliterateTibetan = `https://tulkuajam.org/TransliterateTibetan/TransliterateTibetan.php`
                // for each tibText
                $('.cue>p[class^="tibText"]')// .slice(0,10)
                .each(async function(i,a){
                    // remove chinTrans and engTrans
                    $(a).nextAll('[class^=chinTrans], [class^=engTrans]').remove();
                    // transliterate tibetan to chinese and append after tibetan
                    var chin = await fetch(`${TransliterateTibetan}?Tib00=${$(a).text()}&TransID=C001`).then(t=>t.text())
                    $(a).after(`<p class="chinTrans"><span class="chinTransA">${chin}</span></p>`)
                })
                if(currentUser){ console.log(currentUser)
                    if(currentUser.user_data.TransEditor==true){ //}.uid=='4lQABG389ST60mF8FnvmhU2XA2A2'){
                        // setPageRange(window.EVdefault.LineNumber=="visible")
                        setTimeout(function(){
                            var failed = $('failed').map((i,m)=>`${m.textContent}་`).toArray().join('')
                            console.log(failed.split("་").filter(f=>f))

                            $('body').on('click','failed',function(e){ //console.log(e)
                                    console.log(e.target.textContent);
                                    window.open(`https://tulkuajam.org/TransliterateTibetan/TransTableForm2.php?Tib00=${e.target.textContent}&TransID=C001`,'new')
                                })
                        },2000)
                    }
                }

            }
         }
        function transliterate(lanCode){
            var start = performance.now()
            var TransliterateTibetan = `https://tulkuajam.org/TransliterateTibetan/TransliterateTibetan.php`;
            var lang = lanCode=="E001"?"eng":lanCode=="C001"?"chin":'';
            // for each tibText and tibMantra
            $('.cue>p[class^="tibText"], .cue>p[class^="tibMantra"]')
            .each(async function(i,pTib){
                // remove chinTrans and engTrans
                    // $(pTib).nextAll('[class^=chinTrans], [class^=engTrans]').remove();
                    $(pTib).nextAll(`[class^=${lang}Trans]`).remove();
                // transliterate tibetan to english and append after tibetan
                    var txt = await fetch(`${TransliterateTibetan}?Tib00=${$(pTib).text()}&TransID=${lanCode}`).then(t=>t.text())
                    $(pTib).after(`<p class="${lang}Trans"><span class="${lang}TransA">${txt}</span></p>`)
            })
            if(currentUser){
                console.log(currentUser)
                if(currentUser.user_data.TransEditor==true){
                    setTimeout(function(){
                        var failed = $('failed').map((i,m)=>`${m.textContent}་`).toArray().join('')
                        console.log({failed})
                        $('body').on('click','failed',function(e){
                                console.log(e.target.textContent);
                                window.open(`https://tulkuajam.org/TransliterateTibetan/TransTableForm2.php?Tib00=${e.target.textContent}&TransID=${lanCode}`,'new')
                            })
                    },2000)
                }
            }
            console.log(performance.now()-start)
         }
        var TranslateEngMenu ={
            id: 'TransliterateEng',
            text: [{tib:'Transliterate English'},{chin:'Transliterate English'},{eng:'Transliterate English'}],
            glyphicon:'star',
            clickFunction: function(me){
                console.log(me)
                transliterate("E001")
                return
                var TransliterateTibetan = `https://tulkuajam.org/TransliterateTibetan/TransliterateTibetan.php`;
                // for each tibText
                $('.cue>p[class^="tibText"], .cue>p[class^="tibMantra"]')// .slice(0,10)
                .each(async function(i,a){
                    // remove chinTrans and engTrans
                    $(a).nextAll('[class^=chinTrans], [class^=engTrans]').remove();
                    // transliterate tibetan to english and append after tibetan
                    var eng = await fetch(`${TransliterateTibetan}?Tib00=${$(a).text()}&TransID=E001`).then(t=>t.text())
                    $(a).after(`<p class="engTrans"><span class="engTransA">${eng}</span></p>`)
                })
                if(currentUser){ console.log(currentUser)
                    if(currentUser.user_data.TransEditor==true){ //}.uid=='4lQABG389ST60mF8FnvmhU2XA2A2'){
                        // setPageRange(window.EVdefault.LineNumber=="visible")
                        setTimeout(function(){
                            var failed = $('failed').map((i,m)=>`${m.textContent}་`).toArray().join('')
                            console.log({failed})
                            $('body').on('click','failed',function(e){ //console.log(e)
                                    console.log(e.target.textContent);
                                    window.open(`https://tulkuajam.org/TransliterateTibetan/TransTableForm2.php?Tib00=${e.target.textContent}&TransID=E001`,'new')
                                })
                        },2000)
                    }
                }
            }
         }
        var MultiColumnMenu ={
            id: 'MultiColumn',
            text: [{tib:'གྲལ་མང་'},{chin:'多欄'},{eng:'Multi Column'}],
            className:'Menu', glyphicon:'remove',
            clickFunction: function(e){
                event.preventDefault()
                event.stopPropagation()
                bNavbar.toggleMe2(e,
                    function(){
                        $('#Viewer').css({display:'flex',flexWrap:'wrap',justifyContent:"space-evenly"}) //space-between
                        setParam('multicolumn','on')
                        window.EVdefault.multicolumn = "on"
                    },
                    function(){
                        $('#Viewer').css({display:''})
                        delParam('multicolumn')
                        window.EVdefault.multicolumn = "off"
                    }
                )
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            },
         }
        var resetMenu = {
            id:'reset',text:[{tib:'Reset Setting'},{chin:'重整設定'},{eng:'Reset Setting'}],
            className:'Menu', glyphicon:'star',
            clickFunction: function(e){
                localStorage.removeItem('EasyViewer')
                alert('Reset EasyViewer settings....')
                location.href = location.href
            }
         }
        var reLoadMenu = {
            id:'reload',text:[{tib:'Reload'},{chin:'重整頁面'},{eng:'Reload'}],
            className:'Menu', glyphicon:'star',
            clickFunction: function(e){

                // location.href = location.href

                location.reload()

                // const form = document.createElement('form');
                // form.method = "POST";
                // form.action = location.href;
                // document.body.appendChild(form);
                // form.submit();
            }
         }
        var lineNumberMenu = {
            id:'LineNumber',text:[{tib:'Line Number'},{chin:'編號'},{eng:'Line Number'}],
            className:'Menu', glyphicon:'remove',
            clickFunction: function(e){ console.log(e)
                bNavbar.toggleMe2(e,
                    function(){
                        bNavbar.setStyleSingle('div#Viewer > div.cue::before','visibility','')
                        bNavbar.setStyle('#pageRange','visibility','')
                        setParam('linenumber','visible')
                        window.EVdefault.LineNumber="visible"
                    },
                    function(){
                        bNavbar.setStyleSingle('div#Viewer > div.cue::before','visibility','hidden')
                        bNavbar.setStyle('#pageRange','visibility','hidden')
                        delParam('linenumber')
                        window.EVdefault.LineNumber = "hidden"
                    }
                )
                setPageRange(window.EVdefault.LineNumber=="visible")
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            }
         }
        var linePositionMenu = {
            id:'LinePosition',text:[{tib:'Line Position'},{chin:'Line Position'},{eng:'Line Position'}],
            className:'Menu', glyphicon:'remove',
            clickFunction: function(e){ console.log(e)
                bNavbar.toggleMe2(e,
                    function(){
                        bNavbar.setStyle('#pageRange','visibility','')
                        setParam('lineposition','on')
                        window.EVdefault.LinePosition = "on";
                    },
                    function(){
                        bNavbar.setStyle('#pageRange','visibility','hidden')
                        delParam('lineposition')
                        window.EVdefault.LinePosition = "off";
                    }
                )
                setPageRange(window.EVdefault.LinePosition=="on")
                localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
            }
         }
        var versionMenu = {
            id:'version',text:[{tib:'Version '+EasyViewerVersion},{chin:'版本 '+EasyViewerVersion},{eng:'Version '+EasyViewerVersion}],
            className:'Menu', glyphicon:'star',
            clickFunction: function(e){
                // location.reload()
                alert('Version '+EasyViewerVersion)
            }
         }
      // Dropdowns
        var displayDropdown = {
            id:'Menu', text:[{tib: 'ཤར་བཏང་',title: 'ཡི་གེ་ཤར་བཏང་'},{chin:'顯示'},{eng: 'Display',title:'Text display settings'}],
            className:'Menu',
            lis:[
                tibetanMenu,
                chineseMenu,
                ChinesePinYingMenu,
                englishMenu,
                germanMenu,
                // tibetanPingYingMenu,
                // ScrollerMenu,
                // FollowMenu,
                MultiColumnMenu,
                lineNumberMenu,
                linePositionMenu,
                TranslateChinMenu,
                TranslateEngMenu,
                resetMenu,
                reLoadMenu,
                versionMenu,
            ]
         }
      // create dropdowns
        $('ul#navbarLeft').append([
            bNavbar.createLiDropdownObj(displayDropdown),
            // bNavbar.createLiDropdownObj(followDropdown),
         ])
    // follow Menu
        var followDropdown = {
            id:'Follow', text: "Follow",
            className: 'Menu',
            lis:[
                FollowMenu,
                FollowPage,
                FollowDelay
            ]
         }
        $('ul#navbarLeft').append([
            // bNavbar.createLiDropdownObj(followDropdown),
         ])
    // scroller Menu
        var scrollerDropdown = {
            id:'Scroller', text: "Scroller",
            className: 'Menu',
            lis:[
                ScrollerMenu,
                // EnablePageRange
            ]
        }
        $('ul#navbarLeft').append([
            bNavbar.createLiDropdownObj(scrollerDropdown)
         ])
    // overall Fontsize + -
        $('ul#navbarLeft').append([
            bNavbar.createMenu({
                id: 'plus',
                text: '',
                title: 'increase overall fontsize',
                glyphicon:'plus',
                clickFunction: function(me){
                    // console.log(me)
                    // bNavbar.setStyleAll('.cue','font-size','++0.1em')
                    var viewerSize = (parseFloat( $('#Viewer').css('fontSize') ) * 1.1).toFixed(1) + 'px'
                    bNavbar.setStyleAll('#Viewer','font-size', viewerSize)
                    window.EVdefault.fontSize = $('#Viewer').css('font-size')
                    localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
                }
            }),
            bNavbar.createMenu({
                id: 'minus',
                text: '',
                title: 'decrease overall fontsize',
                glyphicon:'minus',
                clickFunction: function(me){
                    // console.log(me)
                    // bNavbar.setStyleAll('.cue','font-size','--0.1em')
                    var viewerSize = (parseFloat( $('#Viewer').css('fontSize') ) * 0.9).toFixed(1) + 'px'
                    bNavbar.setStyleAll('#Viewer','font-size', viewerSize)
                    window.EVdefault.fontSize = $('#Viewer').css('font-size')
                    localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
                }
            }),
            // bNavbar.createMenu(ScrollerMenu),
            // bNavbar.createMenu(FollowMenu),
            ])
    // PrayerList Menu: from list.js
        function makePrayerList(){
            var menuPrayerList = PrayerList.map(function(prayer,index){
                return {
                    id: prayer.eng.match(/[a-zA-Z0-9]+/g).join('').replace(/^[0-9]+/,""),
                    text:[{tib:`${index+1}. ${prayer.tib}`},{chin:`${index+1}. ${prayer.chin}`},{eng:`${index+1}. ${prayer.eng}`}],
                    className:'Span',
                    glyphicon:'',
                    data: prayer.filename,
                    clickFunction: function(e){
                        $('#Viewer').html('<div class="lds-spinner center"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>')
                        var prayer = e.getAttribute('data-data'); console.log(prayer);
                        location.search = `?prayer=${encodeURI(prayer)}`
                    }
                }
            })
            var MenuPrayerListDropdownObject = {
                id:'prayerList',
                text:[{tib:'དཔེ་ཆ།'}, {chin:'法本'}, {eng:'Prayer'}],
                lis: menuPrayerList
            }
            bNavbar.appendNavbarRight([
                bNavbar.createDropdownMenu(MenuPrayerListDropdownObject),
            ],1);
        }
    // BookList Menu: from json folder
        async function makeBookList(){
            // var cors = "https://tulkuajam.org:8089/"
            var res = await fetch(`https://${location.hostname}/EasyViewerWebBab/EasyViewer5/dist/json/getV2docx.php`).then(res=>res.text())
            BookList = res.split('\\n').filter(f=>f); // console.log(BookList)
            var menuBookList = BookList.map(function(book,index){
                return {
                    id: book.match(/[a-zA-Z0-9]+/g).join('').replace(/^[0-9]+/,""),
                    text:`${index+1}. ${book}`,
                    className:'Span',
                    glyphicon:'',
                    data: book,
                    clickFunction: function(e){
                        $('#Viewer').html('<div class="lds-spinner center"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>')
                        var book = e.getAttribute('data-data'); console.log(book);
                        location.search = `?book=${encodeURI(book)}`
                    }
                }
            })
            var MenuBookListDropdownObject = {
                id:'bookList',
                text:[{tib:'དཔེ་ཆ།'}, {chin:'法本'}, {eng:'Book'}],
                lis: menuBookList
            }
            bNavbar.appendNavbarRight(bNavbar.createDropdownMenu(MenuBookListDropdownObject),1);
        }
    // textList Menu: not used
        ;(async function(){
            var res = await fetch(`https://${location.hostname}/EasyViewerWebBab/EasyViewer5/dist/text/getV2docx.php`).then(res=>res.text())
            TextList = await res.split('\\n').filter(f=>f); // console.log(TextList)
            var menuTextList = TextList.map(function(text,index){
                return {
                    id: text.match(/[a-zA-Z0-9]+/g).join('').replace(/^[0-9]+/,""),
                    text:`${index+1}. ${text}`,
                    className:'Span',
                    glyphicon:'',
                    data: text,
                    clickFunction: function(e){
                        $('#Viewer').html('<div class="lds-spinner center"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>')
                        var text = e.getAttribute('data-data'); console.log(text);
                        // settext(text)
                        location.search = `?text=${encodeURI(text)}`
                        // para.text = text;
                        // window.localStorage.setItem("EasyViewer",JSON.stringify(para))
                    }
                }
            })
            var MenuTextListDropdownObject = {
                id:'textList',
                text:[{tib:'དཔེ་ཆ།'}, {chin:'法本'}, {eng:'Text'}],
                lis: menuTextList
            }
            bNavbar.appendNavbarRight(bNavbar.createDropdownMenu(MenuTextListDropdownObject),1);
        })//()
    // FolderList Menu: used on login
        //;(
            async function makeList(accessList){
                var _lis = []
                for(var list of accessList.split(',')){ console.log({list})
                    /**
                     * php can only run from https://tulkuajam.org server
                     */
                        // // 2025-12-08 try to use the current folder exp: dist2 using location host+pathname: OK
                        // var res  = await fetch(`https://${location.host+location.pathname}getV3docx.php?id=${list}`).then(res=>res.text())
                        // // 2025-09-02 try to use the current folder exp: dist2 using location hostname+pathname: OK
                        // var res  = await fetch(`https://${location.hostname+location.pathname}getV3docx.php?id=${list}`).then(res=>res.text())

                    // set your output folder
                    var dist = "dist2"
                    var res  = await fetch(`https://${location.hostname}/EasyViewerWebBab/EasyViewer5/${dist}/getV3docx.php?id=${list}`).then(res=>res.text())
                    console.log('test',res)
                    UserList = res.split('\\n').filter(f=>f)//.map(m=>m.replace(`${list}/`,``)); // console.log(UserList)
                    var menuUserList = UserList.map(function(text,index){
                        return {
                            id: text.match(/[a-zA-Z0-9]+/g).join('').replace(/^[0-9]+/,""),
                            text:`${index+1}. ${text.replace(list+"/","")}`,
                            className:'Span',
                            glyphicon:'',
                            data: `${text}`,
                            clickFunction: function(e){
                                $('#Viewer').html('<div class="lds-spinner center"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>')
                                var [list,text] = e.getAttribute('data-data').split('/')//[1];
                                // var list = e.getAttribute('data-data').split('/')[0]
                                location.search = `?${list}=${encodeURI(text)}`
                            }
                        }
                    })
                    _lis = [..._lis,{ className:'dropdown-header', text:list }, ...menuUserList]
                }
                var MenuUserListDropdownObject = {
                    id:"Folder",
                    text:[{tib:'Folder'}, {chin:'Folder'}, {eng:'Folder'}],
                    lis:_lis
                }
                console.log({MenuUserListDropdownObject})
                bNavbar.appendNavbarRight(bNavbar.createDropdownMenu(MenuUserListDropdownObject),1);
        }
        //)('tulkuajam')
    // ContentList Menu
        async function setContentListMenu(){
            // await firebase.auth().signInWithEmailAndPassword('tulkuajam@hotmail.com','@IschiTsering2')
            //console.log({currentUser})
            //if(currentUser.email=="tulkuajam@hotmail.com"){
            var fData = await firebase.database().ref('EasyViewer5/FilenameTranslator').once('value')
                fData = await fData.val()
            //}
            console.log({fData})
            var menuContentList = ContentList.map(function(content,index){ //console.log(index,content)
                content = decodeURIComponent(content)
                var fDataKey = content.replace(/V2|.docx|\d|\-+/g,'')

                var tib  = fData[fDataKey]?fData[fDataKey].tib :content;
                var chin = fData[fDataKey]?fData[fDataKey].chin:content;
                var eng  = fData[fDataKey]?fData[fDataKey].eng :content;
                return {
                    id: content.match(/[a-zA-Z0-9]+/g).join('').replace(/^[0-9]+/,""),
                    // text:`${index+1}. ${content}`,
                    text:[
                        {tib :`${index+1}. ${tib}`},
                        {chin:`${index+1}. ${chin}`},
                        {eng :`${index+1}. ${eng}`}],
                    className:'Span',
                    glyphicon:'',
                    data: content,
                    clickFunction:async function(e){ console.log(e)
                        ContentList = ContentList.map(m=>decodeURIComponent(m))
                        var content = e.getAttribute('data-data'); console.log(ContentList.indexOf(content));
                        // scrollIntoViewOptions Optional
                        // A Boolean or an object with the following options:
                        // {
                        // behavior: "auto"  | "instant" | "smooth",
                        // block:    "start" | "center" | "end" | "nearest",
                        // inline:    "start" | "center" | "end" | "nearest",
                        // }
                        console.log(`#${ContentList.indexOf(content)}_1`)
                        $(`#${ContentList.indexOf(content)}_1`)[0].scrollIntoView({ block: 'start',  behavior: 'smooth' })
                        $('#navbarNavbar').hide()
                        // location.search = `?prayer=${encodeURI(content)}`
                        // await setPrayer(decodeURI(content))
                    }
                }
            })
            var MenuContentListDropdownObject = {
                id:'contentList',
                text:[{tib:'དཀར་ཆག'}, {chin:'目錄'}, {eng:'Content'}],
                lis: menuContentList
            }
            bNavbar.appendNavbarLeft([
                bNavbar.createDropdownMenu(MenuContentListDropdownObject),
            ]);
         }
    // FontList Menu
        var menuFontList = FontList.map(function(font,index){
            return {
                id:font.eng,
                text:[{tib:`${index+1}. ${font.tib}`}, {chin:`${index+1}. ${font.chin}`}, {eng:`${index+1}. ${font.eng}`}],
                className:'Span',glyphicon:'',
                data: font.fontName,
                clickFunction: function(e){console.log(e.id)
                    var tibetanFontname = e.getAttribute('data-data'); console.log(tibetanFontname);
                    setTibetanFont(tibetanFontname)
                    window.EVdefault.Language.Tibetan.fontFamily = encodeURI(tibetanFontname);
                    localStorage.setItem('EasyViewer',JSON.stringify(window.EVdefault))
                }
            }
            })
        var MenuFontListDropdownObject = {
            id:'fontListDropdown',
            text:[{tib:'ཡིག་གཟུགས།'}, {chin:'字形'}, {eng:'Font'}],
            lis: menuFontList
            }

        bNavbar.appendNavbarLeft([
            bNavbar.createDropdownMenu(MenuFontListDropdownObject)
            ]);

    // Language Menu
        var LangMenuTib = {
            id:'LangMenuTib',text:'བོད', className:'Menu',
            clickFunction: function(){bNavbar.changeLanguageBarText('tib')}
         }
        var LangMenuChin = {
            id:'LangMenuChin',text:'中', className:'Menu',
            clickFunction: function(){bNavbar.changeLanguageBarText('chin')}
         }
        var LangMenuEng = {
            id:'LangMenuEng',text:'En', className:'Menu',
            clickFunction: function(){bNavbar.changeLanguageBarText('eng')}
         }
        bNavbar.appendNavbarRight(
            bNavbar.createDropdownMenu({
                id: 'LangMenuDrop', text:[{tib:'བོད'},{chin:'中'},{eng:'En'}],
                className: 'Menu',
                lis: [
                    LangMenuTib,
                    LangMenuChin,
                    LangMenuEng]
                }
            )
         );
        bNavbar.appendNavbarRight(
            bNavbar.createDropdownMenu({
                id:'LoginStatus',
                text:'Login'||[{tib: 'ཤར་བཏང་'},{chin:'顯示'},{eng: 'Display'}],
                img: true,
                className:'Menu',
                lis:[
                    {
                        id: 'loginas',
                        className:'dropdown-header',
                        text:'Login with'
                    },
                    // {
                    //     id: 'facebook',
                    //     // text: [{tib:'tibFacebook'},{chin:'chinFacebook'},{eng:'engFacebook'}],
                    //     text: 'Facebook',
                    //     // imgsrc: 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg',
                    //     // style: 'background-color: #3b5998;',
                    //     clickFunction: function(me){
                    //         var provider = new firebase.auth.FacebookAuthProvider();
                    //         firebase.auth().signInWithRedirect(provider);
                    //     }
                    // },
                    {
                        id: 'google',
                        // text: [{tib:'tibGoogle'},{chin:'chinGoogle'},{eng:'engGoogle'}],
                        text: 'Google',
                        // imgsrc: 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg',
                        clickFunction: function(me){
                            var provider = new firebase.auth.GoogleAuthProvider();
                            // firebase.auth().signInWithRedirect(provider);
                            firebase.auth()
                            .signInWithPopup(provider)
                            .then((result) => {
                                /** @type {firebase.auth.OAuthCredential} */
                                var credential = result.credential;

                                // This gives you a Google Access Token. You can use it to access the Google API.
                                var token = credential.accessToken;
                                // The signed-in user info.
                                var user = result.user;
                                // ...
                            }).catch((error) => {
                                // Handle Errors here.
                                var errorCode = error.code;
                                var errorMessage = error.message;
                                // The email of the user's account used.
                                var email = error.email;
                                // The firebase.auth.AuthCredential type that was used.
                                var credential = error.credential;
                                // ...
                            });
                        }
                    },
                    // {
                    //     id: 'email',
                    //     // text: [{tib:'tibGoogle'},{chin:'chinGoogle'},{eng:'engGoogle'}],
                    //     text: 'Email',
                    //     // imgsrc: 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg',
                    //     clickFunction: function(me){
                    //         window.location.href = "//tulkuajam.org/firebaseui-web-master/demo/public" //"login.html"
                    //     }
                    // },
                    // {
                    //     id:'loginasdivider2',
                    //     className:'divider'
                    // },
                    {
                        id:'loggedinas',
                        className:'dropdown-header',
                        text:'Logged in as'
                    },
                    {
                        id:'displayname',
                        className: 'dropdown-header',
                        text:''
                    },
                    {
                        id: 'signinemail',
                        text: '',
                        className:'dropdown-header'
                    },
                    {
                        id: 'logout',
                        text: 'Logout',
                        clickFunction: function(val){
                            firebase.auth().signOut();
                        }
                    }
                ]
             })
         )
    // firebase.auth()
        async function getUserData(uid){
            var data = await fb.database().ref(`EasyViewer5/${uid}`).once('value')
            .then(snapshot=>{
                return snapshot.val()
            })
            .catch((error)=>{ // permission error, fail silently return null
                console.log(error)
                return null
            })
            return data
         }
        var currentUser = '';
        firebase.auth().onAuthStateChanged(async function(user) {
            window.user = user;
            // user.updateEmail("user@example.com").then(() => {
            //     // Update successful
            //     // ...
            //   }).catch((error) => {
            //     // An error occurred
            //     // ...
            //   });
             if (user) {
                console.log(`signed in`,user); // User is signed in.
                 /* set elements */
                    currentUser = user;
                    $('#LoginStatusImg').attr('src', user.providerData[0].photoURL)
                    $('#displayname').text(user.displayName);
                    $('#signinemail').text(user.providerData[0].email)
                 /* hide elements for all user*/
                    $('#loginas, #facebook, #google').css('display','none') // login elements
                    $('#prayerList, #bookList ,#textList').css('display','none') // list
                    // $('#navbarBody>ul>li[id]').hide()
                 /* show elements for all user*/
                    $('#logout').show()
                    $('#displayname').show()
                 /* show elements per user*/
                    console.log({userId:user.uid})

                 /* use uid to get allowed list */
                    console.log(user)
                    user.user_data = await getUserData(user.uid);
                    console.log(user.user_data)
                    // check accessList
                    if(user.user_data?.accessList){
                        makeList(user.user_data.accessList)
                     }
                    // check BookList
                    if(user.user_data?.BookList==true){
                        makeBookList()
                     }
                    // check PrayerList
                    if(user.user_data?.PrayerList==true){
                        makePrayerList()
                     }
                    return
                 /********************************/
                  // '4lQABG389ST60mF8FnvmhU2XA2A2' // tulkuajam@gmail.com
                  // 'ZMzAvI0DGIR4S6JolUB1S71FgGH3' // tulkuajam@gmail.com
                  // 'DPKRRv1j7EXWX6CHSpYK9AuuKUn1' // knowingnothing@yahoo.com.tw
                  // '2PZOo2Pr7vcTqCekkrywwqTHtWt2' // tulkuajam@palyul.org
                  // 'S2r0gGUYnpNKD9yrOlo6ZWZusrx2' // peilantung12@gmail.com
                  // 'mjX8nTxZVjbwOp2SjLaBmhWtUYt2' // wusuching.tw@gmail.com
                  // 'UtpKto60CtXEjNswljkJ9z5CYL02' // dondrubpemanamgyal@gmail.com


                    fb.database().ref(`EasyViewer5/${user.uid}`).once('value').then((snapshot) => {
                    if (snapshot.exists()) {
                        $(function(){
                            console.log(snapshot.val());
                            snapshot.val().accessList.split(',').forEach(fe=>{
                                console.log(`#${fe}`,$(`#${fe}`))
                                $(`#${fe}`).show()
                            })
                        })
                    } else {
                        console.log("No data available");
                    }
                    }).catch((error) => {
                        console.error(error);
                    });
                    // fb.database().ref(`EasyViewer5/${user.uid}`).set({accessList:"prayerList,bookList,textList"})
                    // fb.database().ref(`EasyViewer5/${user.uid}`).set({accessList:"prayerList,bookList"})
                    return
                    if(user.uid=='4lQABG389ST60mF8FnvmhU2XA2A2'){ // tulkuajam@gmail.com
                        console.log(`signed in as ${user.displayName}, uid: ${user.uid}, e-mail: ${user.email}.`); // User is signed in.

                        // $('#LoginStatusImg, #signinemail, #loggedinas, #logout, #displayname, #prayerList, #Follow, #bookList').css('display','');
                        // $('#navbarBody>ul>li[id]').show()
                        // $('#navbarBody>ul#navbarRight>li[id*="List"]').show() // show all menu with List id
                        enableChinEdit(true)
                        $('#LoginStatusImg, #signinemail, #loggedinas, #logout #displayname').css('display','');

                    }else if(user.uid=='DPKRRv1j7EXWX6CHSpYK9AuuKUn1'){ // knowingnothing@yahoo.com.tw
                        console.log(`signed in as ${user.displayName}, uid: ${user.uid}, e-mail: ${user.email}.`); // User is signed in.
                        $('#navbarBody>ul#navbarRight>li[id*="textList"]').show() // show all menu with textList id
                        enableChinEdit(true)
                        $('#LoginStatusImg, #signinemail, #loggedinas, #logout #displayname').css('display','');

                    }else if(user.uid=='2PZOo2Pr7vcTqCekkrywwqTHtWt2'){ // tulkuajam@palyul.org
                        console.log(`signed in as ${user.displayName}, uid: ${user.uid}, e-mail: ${user.email}.`); // User is signed in.
                        $('#navbarBody>ul#navbarRight>li[id*="textList"]').show() // show all menu with textList id
                        enableChinEdit(true)
                        $('#LoginStatusImg, #signinemail, #loggedinas, #logout #displayname').css('display','');
                        // signed in as Tulku Ajam, uid: 2PZOo2Pr7vcTqCekkrywwqTHtWt2, e-mail: null.
                    }else if(user.uid=='S2r0gGUYnpNKD9yrOlo6ZWZusrx2'){ // peilantung12@gmail.com
                        console.log(`signed in as ${user.displayName}, uid: ${user.uid}, e-mail: ${user.email}.`); // User is signed in.
                        $('#navbarBody>ul#navbarRight>li[id*="textList"]').show() // show all menu with textList id
                        enableChinEdit(true)
                        $('#LoginStatusImg, #signinemail, #loggedinas, #logout #displayname').css('display','');
                        // S2r0gGUYnpNKD9yrOlo6ZWZusrx2
                    }else{
                        console.log(`signed in as ${user.displayName}, uid: ${user.uid}, e-mail: ${user.email}.`); // User is signed in.
                        $('#LoginStatusImg, #signinemail, #loggedinas, #logout #displayname').css('display','');
                        enableChinEdit(false)
                    }
                    if (typeof FBLoggedIn == "function"){ FBLoggedIn(user) }
                    // $('#Scroller').show()
                    // $('#Follow').show() //.hide()
             } else {
                 console.log('signed out', user); // User is signed out.
                 enableChinEdit(false)
                 /* set elements */
                    currentUser = '';
                    $('#LoginStatusImg').attr('src', '');
                    $('#SignInEmail').text('');
                 /* hide elements */
                     $('#LoginStatusImg, #signinemail, #loggedinas, #logout, #displayname, #prayerList, #Follow, #bookList, #textList, #Folder').css('display','none');
                 /* show elements */
                    $('#loginas, #facebook, #google').css('display','');
                    if (typeof FBLoggedOut == "function"){ FBLoggedOut() }
                    $('#Scroller').hide()
                    // $('#Follow').show()
                // location.href = location.href
                $('#navbarRight>li:not(#LangMenuDrop, #LoginStatus)').remove()
             }
         }, function(error) {
             console.log(error);
         });
    // Login Menu
        bNavbar.appendNavbarDropdown('#LoginStatus',[ ]);

    // appended Menus
        bNavbar.makeStylesMenu()
        $('li#Menu ul').append(
            // bNavbar.createMenu({
            //     id: 'Translate',
            //     text: [{tib:'Translate'},{chin:'Translate'},{eng:'Translate'}],
            //     glyphicon:'star',
            //     clickFunction: function(me){
            //         console.log(me)
            //         // setStyleAll('div.cue','display','inline')
            //         // toggleStyles(me, 'div.cue', 'display','block','inline')
            //         var TransliterateTibetan = 'https://tulkuajam.org/TransliterateTibetan/TransliterateTibetan.php'
            //         // $('.cue>span.tibTextA')
            //         // $('.cue>div[class^="tibText"]')
            //         $('.cue>p[class^="tibText"]')
            //         // .slice(0,10)
            //         .each(async function(i,a){
            //             $(a).nextAll('[class^=chinTrans], [class^=engTrans]').remove();

            //             var chin = await fetch(`${TransliterateTibetan}?Tib00=${$(a).text()}&TransID=C001`); chin = await chin.text();
            //             console.log(chin)
            //             $(a).after(`<div class="chinTrans">${chin}</span>`)

            //             var eng = await fetch(`${TransliterateTibetan}?Tib00=${$(a).text()}&TransID=E001`); eng = await eng.text();
            //             console.log(eng)
            //             $(a).after(`<div class="engTrans">${eng}</span>`)
            //         })
            //     }
            // })
            )

    // onClick
        $('body').on('click', '#output, #Viewer ',function(e){
            console.log(e.target.tagName)
            if (// click on P element Toggle Menu
                e.target.tagName != 'A' &&
                e.target.tagName != 'SPAN' &&
                e.target.tagName != 'BUTTON'
                ){
                $('#navbarNavbar').toggle();
                // $('body').css('grid-template-rows',$('#navbarNavbar').css('display') == 'block'?'50px 1fr':'0px 1fr')
                $('body').css('grid-template-rows',$('#navbarNavbar').css('display') == 'block'?$('#navbarNavbar').height()+'px 1fr':'0px 1fr')
                // $('#pageRange').toggleClass('pageRange')
            }else if(// click on RepeatLink element
                e.target.tagName=='A' && /RepeatLink/.test(e.target.className)
                ){
                console.log( e.target )
                var parentCue = $(e.target).parents('.cue')
                var parentTargetCue=$(parentCue.data('target')).parents('.cue')
                var times     = $(parentCue).attr('data-times')
                var time      = $(parentCue).attr('data-time')
                console.log(parentCue,parentTargetCue,times,time)
                // var target    = decodeURI(e.target.hash)
                if(times&&time&&e.target.hash){
                    var target    = decodeURI(e.target.hash)
                    if(time>=times){ // stop repeating
                        e.preventDefault()
                    }else{ // repeat
                        $('#navbarNavbar').hide();
                        $('body').css('grid-template-rows', '10px 1fr')
                        $(parentCue).attr('data-time',(time*1)+1)
                        e.preventDefault()
                        e.stopImmediatePropagation()
                        e.stopPropagation()
                        // alert('off')
                        // $(target).parents('.cue')[0].scrollIntoView({behavior: "smooth", block: "start",inline:'start'})
                        // $(target).parents('.cue')[0].scrollIntoView({behavior: "smooth", block: "start",inline:'start'})

                        // const { scrollX, scrollY } = window
                        // console.log('scroll',{ scrollX, scrollY })
                        // $(target).parents('.cue')[0].scrollIntoView(false)
                        // Assuming 'element' is the reference to the element you want to bring into view
                        const element = $(target).parents('.cue')[0]
                        const elementRect = element.getBoundingClientRect();
                        console.log(elementRect)
                        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                        const newPosition = elementRect.top + scrollPosition;
                        if(!window.isElementInViewport(element)){
                            window.scrollTo({
                                top: newPosition-10,
                                behavior: 'smooth' // Optional, to animate the scroll
                            });
                        }

                        // $(target).parents('.cue')[0].scrollIntoView({block: "start",inline:'start'})

                        // $(target).parents('.cue')[0].scrollIntoView({behavior: "auto", block: "start",inline:'start'})
                        // console.log('scroll',{ scrollX, scrollY })
                        // window.scroll(scrollX, scrollY)
                        $(target).parents('p').find('span')
                            .animate({ color: "black" },500)
                            .animate({ color: "red"   },500)
                            .css({"text-decoration":"underline"})
                        // $($(decodeURIComponent($0.hash)).parents('.cue')[0]).nextUntil($($0).parents('.cue'))
                        //     .filter('.cue').has('p.tibRepeatLinkP')
                        //     .each((i,v)=>{
                        //         // console.log(v,$(v).data("time",1),$(v).find('a')[0].className.match(/\d+/)?$(v).find('a')[0].className.match(/\d+/)[0]*1:'x')
                        //         console.log(v.getAttribute('data-times'),v.getAttribute('data-time'),v.setAttribute('data-time',"1"))
                        //     })

                        // $(v).attr('data-time','2')

                        // console.log( "debug",parentTargetCue.nextUntil(parentCue).filter('.cue').has('p.tibRepeatLinkP')  )

                        /* 2024-03-22 */
                        // reset all tibRepeatLinkP's between this(parentCue) and target(prentTargetCue)
                        parentTargetCue
                            .nextUntil(parentCue)
                            .filter('.cue').has('p.tibRepeatLinkP') // all tibRepeatLinkP
                            .each((i,v)=>$(v).attr('data-time',1))
                    }
                }
            }else if(// click on link
                e.target.tagName=='A'
                ){
                    $('#navbarNavbar').hide();
                    $('body').css('grid-template-rows', '10px 1fr')
                    // e.preventDefault()
                    var target = decodeURI(e.target.hash)
                    $(target).parents('.cue')[0].scrollIntoView({behavior: "smooth", block: "start",inline:'start'})
                    $(target).parents('p').find('span')
                        .animate({ color: "black" },500)
                        .animate({ color: "red"   },500)
                        .css({"text-decoration":"underline"})
            }
          })
    //
    // // onmessage
    //     window.onmessage = function(e){
    //         console.log(e.data)
    //         // $('#Viewer').prepend(e.data);
    //     }

    // load defaults
        bNavbar.changeLanguageBarText(defaultMenuLanguage)
    // set other paras hide/show function
        function setOtherParas(paras){ console.log({paras}) // hide/show
            if(paras.hide){ console.log(paras.hide)
                var hides = paras.hide.split(';')
                hides.forEach((h)=>{
                    if(h) $(`[class*="${h}"]`).hide()
                })
            }
            if(paras.show){ console.log(paras.show)
                var shows = paras.show.split(';')
                shows.forEach((h)=>{
                    if(h) $(`[class*="${h}"]`).show()
                })
            }
        }
    // timestamp
        function addTimestampToUrl() {
            const timestamp = Date.now();
            const urlObj = new URL(window.location.href);
            urlObj.searchParams.set('ts', timestamp);
            history.replaceState(null, '', urlObj.toString());
            }
        addTimestampToUrl()
    // Viewer
        // pageRange output
            function debounce(func, interval) { console.log(interval)
                var lastCall = -1;
                return function() {
                    clearTimeout(lastCall);
                    var args = arguments;
                    var self = this;
                    lastCall = setTimeout(function() {
                        func.apply(self, args);
                    }, interval);
                };
             }
            function getCuesInViewport(parentElement){
                var found = []
                var child;
                var scrollParent = parentElement
                var children = scrollParent.querySelectorAll('.cue')
                for(var c=0;c<children.length;c++){
                    child = children[c]
                    var viewTop     = scrollParent.scrollTop;
                    var viewBottom  = scrollParent.scrollTop    + scrollParent.offsetHeight
                    var childTop    = child.offsetTop
                    var childBottom = child.offsetTop + child.offsetHeight
                    // console.log( childTop,'>=',scrollTop)
                    // console.log(childBottom,'<',bottom)
                    if(childTop>=viewTop && childBottom<=viewBottom){ // element is between top and bottom
                        // get only first and last
                        if(found.length<1){ // first found
                            found[0]={c,child}
                        }else{
                            found[1]={c,child} // second and thereafter found
                        }
                    }else{
                        if(found.length>0){ // found once: break after next not found
                            break;
                        }
                    }
                }
                return found
             }
            function setPageRange(onOff){ console.log('setPageRange',onOff)
                if(onOff){
                    if ($('#pageRange').length==0){
                        $('#Viewer').prepend('<span id="pageRange"></span>')
                    }
                    if(user?.uid=='ZMzAvI0DGIR4S6JolUB1S71FgGH3'){
                        $(document)
                            .on('scroll',debounce(function(){ // debonce(): wait till user stop scrolling
                                var Cues = getCuesInViewport($('html')[0])
                                console.log(Cues[0],Cues[1])
                                if(Cues[0] && Cues[1]){
                                    $('#pageRange').text(`${Cues[0].c+1}/${$('.cue').length}`)
                                    socket8753.emit('msgText',
                                    `<div class="lineNo" style="
                                            position: fixed;
                                            top: 0;
                                            left: 0;
                                            width: 100%;
                                            height: 100%;
                                            background: black;
                                            color: white;
                                            font-size: 20em;
                                            font-weight: bold;
                                    ">
                                    <div style="
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        transform: translate(-50%, -50%);
                                        padding: 10px;
                                    ">${Cues[0].c+1}</div>
                                    </div>`)
                                }
                            },100))
                            .trigger('scroll')
                     }else{
                        socket8753.on('msgText',function (msgText) {
                            console.log($(msgText).text().replace(/\n* */g,''))
                            $('#pageRange').text($(msgText).text().replace(/\n* */g,''))
                        })
                     }
                }else{
                    $('#pageRange').remove()
                    $(document).off('scroll')
                    socket8753.emit('msgText','')
                }
             }
        // css settings
            $('#output, #Viewer').css('cursor','pointer').css('grid-area','output')
        // load default Settings
            console.log('setTimeout start')
            setTimeout(async () => {
              // load prayer or book
                var start = performance.now()
                var para = getParas(); console.log({para})
                if(para.prayer){
                    para.prayer = decodeURIComponent(para.prayer); console.log(para.prayer)
                    ContentList = para.prayer.split(';'); //console.log(ContentList)
                    await setPrayer("json",para.prayer)
                    setContentListMenu()
                    setOtherParas(para)
                }else if (para.book){
                    para.book = decodeURIComponent(para.book); console.log(para.book)
                    ContentList = para.book.split(';'); //console.log(ContentList)
                    await setPrayer("json",para.book)
                    setContentListMenu()
                    setOtherParas(para)
                // }else if (para.text){
                //     para.text = decodeURIComponent(para.text); console.log(para.text)
                //     ContentList = para.text.split(';'); //console.log(ContentList)
                //     await setPrayer(para.folder,para.text)
                //     setContentListMenu()
                //     setOtherParas(para)
                }else if (para.url){
                    para.url = decodeURIComponent(para.url); console.log(para.url)
                    folder = para.url.split("/").slice(0,-1).join("/")
                    docx   = para.url.split("/").slice(-1)[0]
                    console.log({folder,docx})
                    await setPrayer(folder,docx)
                }else if(Object.keys(para).length>0){
                    var folder = Object.keys(para)[0]
                    var docx   = Object.values(para)[0]
                    docx = decodeURIComponent(docx); console.log(docx)
                    ContentList = docx.split(';'); //console.log(ContentList)
                    await setPrayer(folder,docx)
                    setContentListMenu()
                    setOtherParas(para)
                }else{
                    $('#Viewer').html(`<div class="center">${[{tib:`དཔེ་ཆ་ཞིག་བསྡམ་གནང་རོགས`},{eng:`Select Prayer in Menu.`},{chin:`Select Prayer in Menu.`}].map(m=>`<span class="${Object.entries(m)[0][0]}Menu>${Object.entries(m)[0][1]}</span>`).join('')}</div>`)
                }
                console.log(performance.now()-start)

                updatePseudoCounters()

              // enable remark toggle
                    // $('[class*="RemarkA"]').off().on('click',function(e){
                    //     e.preventDefault()
                    //     e.stopPropagation()
                    //     var next$ = $(e.target).parent().next()
                    //     if (next$.hasClass('chinRemarkP')){
                    //         console.log( next$.toggle() )
                    //     }
                    // })
                    $('[class*="RemarkA"]').off().on('click',function(e){
                        console.log('RemarkA click',e.currentTarget.className)
                        e.preventDefault()
                        e.stopPropagation()
                        var remarkP = e.currentTarget.className.replace(/A$/,'P')
                        console.log(remarkP)
                        var next$ = $(e.currentTarget).parent().nextAll("."+remarkP)
                        console.log(next$)
                        if (next$.hasClass(remarkP)){
                            console.log( next$.toggle() )
                        }
                    })

              // 2021-06-12 restore EasyViewer settings
                console.log(window.EVdefault)
                Object.keys(window.EVdefault).map((key,i)=>{ console.log('111',i,key)
                    // check EVdefault version
                        if(key=='version'){
                            //console.log('\t112',key,window.EVdefault[key],EVdefaultSettings[key])
                            if(EVdefaultSettings[key]!=window.EVdefault[key]){
                                console.log('\t\t113','copying default settings')
                                window.EVdefault = EVdefaultSettings
                            }
                        }
                    // #Viewer fontSize
                        if(key=='fontSize'){ //console.log('\t112',key,window.EVdefault[key])
                            bNavbar.setStyleAll('#Viewer', 'fontSize', window.EVdefault.fontSize);
                        }
                    // Multicolumn
                        if(key=="multicolumn"){
                            if(window.EVdefault.multicolumn=="on"){
                                $('#Viewer').css({display:'flex',flexWrap:'wrap',justifyContent:"space-evenly"})
                            }else if(window.EVdefault.multicolumn = "off"){
                                $('#Viewer').css({display:''})
                            }
                            var addclass = window.EVdefault.multicolumn=='on'?'glyphicon-ok':'glyphicon-remove';
                            $(`#MultiColumn span[class*="glyphicon"]:nth-child(1)`)
                                .removeClass('glyphicon-remove glyphicon-ok') // remove any class
                                .addClass(addclass) // add needed class
                        }
                    // LineNumber
                        if(key=='LineNumber'){ //console.log('\t112',key,window.EVdefault[key])
                            bNavbar.setStyleSingle('div#Viewer > div.cue::before','visibility',window.EVdefault.LineNumber)
                            bNavbar.setStyle('#pageRange','visibility',window.EVdefault.LineNumber)
                            if(currentUser){ console.log(currentUser)
                                if(currentUser.uid=='ZMzAvI0DGIR4S6JolUB1S71FgGH3'){
                                    setPageRange(window.EVdefault.LineNumber=="visible")
                                }
                            }
                            var addclass = window.EVdefault.LineNumber=='visible'?'glyphicon-ok':'glyphicon-remove';
                            $(`#LineNumber span[class*="glyphicon"]:nth-child(1)`)
                                .removeClass('glyphicon-remove glyphicon-ok') // remove any class
                                .addClass(addclass) // add neded class
                        }
                    // LinePosition
                        if(key=='LinePosition'){ console.log(key,window.EVdefault[key])
                            // bNavbar.setStyleSingle('div#Viewer > div::before','visibility',window.EVdefault.LineNumber)
                            bNavbar.setStyle('#pageRange','visibility',window.EVdefault.LinePosition=='on'?'':'hidden')
                            if(currentUser){ console.log(currentUser)
                                if(currentUser.uid=='ZMzAvI0DGIR4S6JolUB1S71FgGH3'){
                                    setPageRange(window.EVdefault.LinePosition=="on")
                                }
                            }
                            var addclass = window.EVdefault.LinePosition=='on'?'glyphicon-ok':'glyphicon-remove';
                            $(`#LinePosition span[class*="glyphicon"]:nth-child(1)`)
                                .removeClass('glyphicon-remove glyphicon-ok') // remove any class
                                .addClass(addclass) // add needed class
                        }
                    // Language
                        if(key=='Language'){
                            Object.keys(window.EVdefault[key]).map((lang,l)=>{
                                console.log(l,lang,searchParams)
                                // all except ChinesePinYing
                                if(lang!="ChinesePinYing"){
                                  // get setting
                                    var setting = window.EVdefault[key][lang]; console.log(lang,setting,setting.display)
                                    if(setting.display=='block'){
                                        appendParam('lang',lang)
                                    }else{
                                        removeParam('lang',lang)
                                    }

                                  // display
                                    bNavbar.setStyleAll(setting.getSelector, 'display', setting.display)
                                    var addclass = setting.display=='block'?'glyphicon-ok':'glyphicon-remove';
                                    $(`#${lang} span[class*="glyphicon"]:nth-child(1)`).removeClass('glyphicon-remove glyphicon-ok').addClass(addclass)
                                  // fontSize
                                    bNavbar.setStyleAll(setting.getSelector, 'fontSize', setting.fontSize)
                                  // fontFamily
                                    if(typeof setting['font-family']=='object'){
                                        setting['font-family'][setting.pinying].forEach(f=>{
                                            bNavbar.setStyleAll(f[0],f[1],f[2])
                                        })
                                    }else{
                                        bNavbar.setStyleAll(setting.getSelector, 'fontFamily', setting.fontFamily)
                                    }
                                }
                            })
                        }
                 })
                // socket8753.disconnect()

                // restore scroll position
                    console.log('restore scroll position setup')
                    var scrollpos = localStorage.getItem('scrollpos');
                    if (scrollpos) {
                        var [scrollpos,timestamp] = scrollpos.split('-');console.log(scrollpos,timestamp)
                        if((Date.now()-timestamp)<60000) window.scrollTo(0, scrollpos);
                        console.log(Date.now()-timestamp)
                    }
                // save scroll position on refresh
                    window.onbeforeunload = function(e) {
                        console.log('save scrollpos-timestamp')
                        localStorage.setItem('scrollpos', `${window.scrollY}-${Date.now()}`);
                    };
                console.log('setTimeout end')
            }, 2000);